import KumosearchError from "./KumosearchError";
import { ImportResponseFail } from "../Documents";

export default class ImportError extends KumosearchError {
  importResults: ImportResponseFail;
  constructor(message, importResults) {
    super(message);
    this.importResults = importResults;
  }
}
